// extracted by mini-css-extract-plugin
export default {"wrap":"uH-z","fullWidth":"vH-z","hideOnDesktop":"wH-z","content":"xH-z","hasOpenedNav":"yH-z","crumbsList":"zH-z","dropdownsWrap":"AH-z"};